'use client';
import React from 'react';
import Div from '@pezeshk-book/ui-kit/div';
import Button from '@pezeshk-book/ui-kit/button';
import process from 'process';
import routes from '@routes';
import { useDispatch } from 'react-redux';
import { PharmaciesActions } from '@store/pharmacies/pharmacies-actions';

const ConfirmOrder = ({ title }: {title: string}) => {
  const dispatch = useDispatch();

  const handleSelectCityModal = (route?: string) => {
    dispatch(PharmaciesActions.setCityModal({ open: true }));
    dispatch(PharmaciesActions.setCityHref({ href: routes['route.pharmacies.otc'] }));
  };

  return (
    <Div className={'justify-center'}>
      <Button disabled={process.env.PHARMACY_CALL_TO_ACTIONS_SERVICE_ACTIVE !== 'true'} onClick={handleSelectCityModal} fontType={'bold'} className={'w-4/5 sm:w-1/2 mt-10'}>
        {title}
      </Button>
    </Div>
  );
};

export default ConfirmOrder;
